module.exports = __webpack_public_path__ + "img/17.860fa44b.png";